import { render } from "./WeatherComponent.vue?vue&type=template&id=70ba19f1"
import script from "./WeatherComponent.vue?vue&type=script&lang=js"
export * from "./WeatherComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__